export default __webpack_public_path__ + "static/media/person-icon-hht2-01.5072fee1.png";